// /credits/* Wrapper — Credit-Pack-Liste + Stripe-Checkout.
// Backend: GET /credits/packs (active packs, sortiert), POST /credits/checkout.

import { apiFetch } from './api';

export interface CreditPack {
  id: string;
  label: string;
  credits: number;
  price_cents: number;
}

export async function fetchCreditPacks(accessToken: string): Promise<ReadonlyArray<CreditPack>> {
  return apiFetch<ReadonlyArray<CreditPack>>('/credits/packs', { accessToken });
}

export async function createCreditCheckout(
  accessToken: string,
  packId: string,
): Promise<{ url: string }> {
  return apiFetch<{ url: string }>('/credits/checkout', {
    method: 'POST',
    accessToken,
    json: { packId },
  });
}

/** Formatiert price_cents als ganze EUR (z.B. 9900 → "99 €"). */
export function formatPriceEur(priceCents: number): string {
  return `${Math.round(priceCents / 100)} €`;
}
